import { Layout } from "@/components/layout";
import { About, Guide, Home, Location, Reservation, Rooms, Specials } from "@/domains";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/home",
                element: <Home />,
            },
            {
                path: "/about",
                element: <About />,
            },
            {
                path: "/location",
                element: <Location />,
            },
            {
                path: "/rooms/:roomIdx",
                element: <Rooms />,
            },
            {
                path: "/specials/:specialIdx",
                element: <Specials />,
            },
            {
                path: "/guide",
                element: <Guide />,
            },
            {
                path: "/reserve",
                element: <Reservation />,
            },
        ],
    },
]);

export default router;
